/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Shy_Boar_KickInputs */

const fr_wide_shy_boar_kick = /** @type {(inputs: Wide_Shy_Boar_KickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration du programme:`)
};

/**

* @param {Wide_Shy_Boar_KickInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const wide_shy_boar_kick = /** @type {((inputs?: Wide_Shy_Boar_KickInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Shy_Boar_KickInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_wide_shy_boar_kick(inputs)
});